export const BILLING_CADENCES = ['monthly', 'semi_annual'] as const;
export const BILLING_CADENCES_NEW = ['monthly', 'paid_in_full'] as const;
